import React from 'react';
import BrandHero from './BrandHero';
import RiskBox from './RiskBox';
import LoginCard from './LoginCard';

export const AuthShell = ({ onAuthSuccess, onErrorBanner }) => {
  return (
    <div className="relative min-h-[100dvh] w-full flex flex-col justify-between overflow-x-hidden">
      {/* Main Responsive Grid Container */}
      <div className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10 flex items-center justify-center">
        <div className="w-full grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center my-auto">
          
          {/* Left Column (Desktop >= 1024px): Brand Intelligence & Institutional Showcase (Span 7) */}
          <div className="lg:col-span-7 space-y-6 sm:space-y-8 order-2 lg:order-1">
            <BrandHero />

            {/* Desktop Risk Governance & Compliance Module */}
            <div className="hidden sm:block">
              <RiskBox collapsible={false} />
            </div>
          </div>

          {/* Right Column (Mobile bottom-sheet / Desktop tactical card): (Span 5) */}
          <div className="lg:col-span-5 w-full flex flex-col justify-end sm:justify-center order-1 lg:order-2">
            <LoginCard 
              onAuthSuccess={onAuthSuccess} 
              onErrorBanner={onErrorBanner}
            />
            
            {/* Mobile-Only Collapsible Risk Disclosure Accordion */}
            <div className="sm:hidden mt-4 pb-[calc(env(safe-area-inset-bottom,0px)+1rem)]">
              <RiskBox collapsible={true} />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default AuthShell;
